import { createClient } from '@supabase/supabase-js';

// -----------------------------------------------------------
// STEP 1: Replace these two values with your Supabase project
// details from: https://supabase.com/dashboard → Project Settings → API
// -----------------------------------------------------------
const SUPABASE_URL = 'https://ivspgocfvzrqelomeuwa.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml2c3Bnb2NmdnpycWVsb21ldXdhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI4NTEwOTIsImV4cCI6MjA5ODQyNzA5Mn0.cFv9NMI2y72tMtTlXG8En-C4-8oFsV4cRkJTmgcDLiE';
// -----------------------------------------------------------

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
